import React, { useEffect } from 'react';

import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { openOrCloseGlobalDialog } from '../../action/dialog/global-dialog';
import { loadOrg } from '../../organization/actions/load-org';
import { userSelector } from '../../reducers/current-user-selectors';
import { lastVisitedOrgIdSelector } from '../../reducers/display-settings-selectors';
import { orgSelector } from '../../reducers/org-selectors';
import { accountSelector } from '../account-selectors';
import { loadAccount } from '../actions/load-account';

import { UiButton } from '../../ui/ui-button';
import { UiDialog } from '../../ui/ui-dialog';
import { accountCarrierRegistration } from '../../web-routes';

const mapStateToProps = (state: any) => {
  const user = userSelector(state);
  const lastVisitedOrgId = user?.username ? lastVisitedOrgIdSelector(state, user.username) : null;
  const org = lastVisitedOrgId ? orgSelector(state, lastVisitedOrgId) : null;
  const account = org?.accountId ? accountSelector(state, org.accountId) : null;

  return {
    lastVisitedOrgId,
    user,
    org,
    account,
  };
};

export const AccountUnregisteredDialog = () => {
  const dispatch = useDispatch();
  const { account, org, lastVisitedOrgId, user } = useSelector(mapStateToProps, shallowEqual);

  const closeDialog = () => dispatch(openOrCloseGlobalDialog('accountUnregisteredDialog', false));

  useEffect(() => {
    // If we run this code without a user or an org context, just immediately close it
    if (!user || !lastVisitedOrgId) {
      closeDialog();
    }
    if (lastVisitedOrgId) {
      dispatch(loadOrg(lastVisitedOrgId));
    }
    if (org?.accountId) {
      dispatch(loadAccount(org.accountId));
    }
  });

  if (!account) {
    return null;
  }

  if (account.businessRegistrationNumber) {
    closeDialog();
    return null;
  }

  return (
    <UiDialog title="Register your company" onClose={closeDialog}>
      <UiDialog.Content>
        <div>
          You must register your company to guarantee continued delivery of your messages by cell
          services (e.g. AT&T, Verizon, etc.). This only takes a moment.
        </div>
        <div className="typo-subtitle u-margin-top">
          Carriers are beginning to block SMS messages from unregistered numbers and will be
          completely blocking them soon. To avoid any interruption in service, please fill in your
          EIN to start your registration.
        </div>
      </UiDialog.Content>
      <UiDialog.Actions>
        <UiButton
          loading={!account}
          linkTo={accountCarrierRegistration(account?.accountId)}
          onClick={closeDialog}
          variant="primary"
        >
          Register Now
        </UiButton>
      </UiDialog.Actions>
    </UiDialog>
  );
};
